import { render } from "./MenuTypeSelector.vue?vue&type=template&id=c22d0026"
import script from "./MenuTypeSelector.vue?vue&type=script&lang=js"
export * from "./MenuTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__